import { isOriginalStockValue, StockLabelValue } from '@tableau/catalog-ui-temp';

import { revertToDefaultLabelAction } from '~src/catalog/actions/labels/RevertToDefaultLabelAction';
import { ILabelValueInfo } from '~src/catalog/models/ILabelValueInfo';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { currentUserIsAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

export const RevertToDefaultLabelValueEntityAction: IEntityAction<ILabelValueInfo, {}> = {
    name: EntityActionNames.RevertToDefaultLabel,
    translateName: Messages.revertToDefaultLabel_action,
    isVisible: (targetItems, state) => selectCatalogingOnSiteEnabled(state) && FeatureFlags.labelManagementEnabled
      && currentUserIsAdmin(state) && isVisible(targetItems[0]),
    isClickable: (_, targetItems) => targetItems.length === 1,
    createReduxAction: (items) => {
        if (!items || items.length === 0 || items.length > 1) {
            throw new Error(Messages.RevertToDefaultLabelError());
        }
        return revertToDefaultLabelAction(items[0]);
    }
};

function isVisible(labelValue: ILabelValueInfo): boolean {
  const stockValue: StockLabelValue = {
    name: labelValue.value,
    description: labelValue.labelDescription,
    elevatedDefault: labelValue.visiblity
  };
  return labelValue.builtIn && !isOriginalStockValue(stockValue);
}